/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SiteNavDropdownContent_navigationModule = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SiteNavDropdownContent_navigationModule",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SiteNavFullWidthDropdownContent_navigationModule",
      "args": null
    }
  ],
  "type": "NavigationModule"
};

module.exports = fragment;
